
import { Options } from "vue-class-component";
import RouterService from "../../services/router.service";
import { ScreenType } from "../../enum/screen.type";
import { MutationTypes } from "../../store/mutations";
import Base from "../base/Base.vue";
import { Game } from "../../model/Game.model";
import GameCard from "../gameCard/gameCard.vue";
@Options({
  components: {
    GameCard
  },
  props: ["games"]
})
export default class ListGame extends Base {
  public games!: Game[];
  public selectedGame: Game = {
    id: 1,
    description: "",
    genre: "",
    imageUrl: "",
    name: "",
    length: "",
    tag: ""
  };

  selectGame(game: any) {
    window.open(`${this.baseUrl}/host/?id=${game.id}`);
  }

  leaderboardGame(game: Game) {
    this.store.commit(MutationTypes.SET_GAME_SELECTED, game);
    RouterService.redirectTo(ScreenType.leaderboard, "gameId", game.id);
  }
}
